import { useContext, useLayoutEffect, useState } from "react";
import CustomizerContext from "../../../../../_helper/Customizer";
import {
    Description,
    FinanceProcessType,
    Name,
    Status,
} from "../../../../../Constant";
import { toast } from "react-toastify";
import { IFinanceProcessTypePayload } from "../FinanceProcessType.types";
import useAuth from "../../../../../Hooks/useAuth";
import useAxiosPrivate from "../../../../../Hooks/useAxiosPrivate";

export default function useFinanceProcessTypeController() {
    const axiosPrivate = useAxiosPrivate();
    const formTitle = FinanceProcessType;
    const { userOrganisationId }: any = useAuth();
    const { layoutURL } = useContext(CustomizerContext);
    const backBtn = `${process.env.PUBLIC_URL}/finance/settings/process-type/${layoutURL}`;
    const [formFields, setFormFields] = useState<any[]>([
        {
            id: "name",
            name: "name",
            label: Name,
            type: "text",
            value: "",
            required: true,
            colSize: 6,
        },

        {
            id: "description",
            name: "description",
            label: Description,
            type: "textarea",
            value: "",
            required: true,
            colSize: 6,
        },

        {
            id: "is_active",
            name: "is_active",
            label: Status,
            type: "switch",
            value: "1",
            colSize: 6,
        },

        {
            id: "prefix",
            name: "prefix",
            label: "Prefix",
            type: "text",
            value: "",
            required: true,
            colSize: 6,
        },

        {
            id: "backend_label",
            name: "backend_label",
            label: "Backend Label",
            type: "text",
            value: "",
            required: true,
            colSize: 6,
        },
    ]);

    // ?? Call on every dependent change
    async function updateFields() {
        const updatedFields = [...formFields];
        setFormFields(updatedFields);
    }

    useLayoutEffect(() => {
        //?? Updates all fields once component is mounted
        updateFields();
    }, []);

    const onSubmit = async (data: IFinanceProcessTypePayload) => {
        data.organisation_id = userOrganisationId;
        await axiosPrivate
            .post("/finances/process/types", data)
            .then((_res) => {
                toast.success(`${_res.data.name} Created Successfully.`);
            })
            .catch((err) => {
                if (err.response && err.response.status === 422) {
                    toast.error("Validation Errors");
                } else if (err.response && err.response.status === 400) {
                    toast.error(err.response.data.detail);
                } else {
                    toast.error("Whoops! Something went wrong");
                }
                throw err;
            });
    };

    return { formTitle, formFields, backBtn, onSubmit };
}
